module.exports = __webpack_public_path__ + "static/img/director_01.dfb0b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/corona/director_01.png
// module id = 4Ucl
// module chunks = 0